/* ============================================================
   Brocmar Smokehouse — Shopify Theme JavaScript
   ============================================================ */

var MODAL_DESC = {
  'S.P.G.B': "Salt, pepper, garlic, butter — the seasoning that works on everything. We just put it on a pretzel and let it do its thing. Rich, savory, and just enough black pepper to keep it interesting. Our best seller since day one, and honestly, we're not surprised.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Smokehouse Rancherz': "Ranch and cheddar are a safe bet. We added hickory-smoked bacon and made it a promise. Creamy, smoky, with that sharp cheddar finish that lingers just long enough. The kind of bag that disappears before you realize you've been snacking for twenty minutes.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Cajun Bayou': "Cayenne, paprika, garlic, and a heat that builds slow then stays. This one's for people who order the spicy option without reading the menu first. Bold seasoning, real kick, zero apology.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Creamy Cheddar Bliss': "Real cheddar, sour cream, a little onion to keep it honest. Smooth, savory, and just tangy enough to make it feel like a decision. The one that converts people who swear they don't have a favorite.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Carolina Krab': "Old Bay, cheddar, and the memory of a Low Country seafood boil. No newspaper. No cleanup. Savory, a little briny, unmistakably coastal. If you grew up on the Carolina coast, this one hits different.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Honey Mustard & Onion': "Sweet, sharp, savory — all three at once. If honey mustard is already your favorite dipping sauce, this just cuts out the middleman. Bright and tangy upfront, with a mellow sweetness that rounds it out.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Southwest Buffalo Blaze': "Buffalo heat with a smoky southwestern lean. Frank's cayenne, chipotle, hickory smoke, and a seasoning blend that hits every part of your palate at once. It's got the heat you want without burning out your taste buds after the first handful.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Pink Himalayan Sea Salt & Vinegar': "The tang hits first. The salt holds it. The crunch brings it home. Built on Himalayan pink salt and real vinegar — sharp and clean, exactly what salt and vinegar should be.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Dill Pickle': "Pure dill pickle — no apologies, no moderation. That bright, vinegary dill flavor in every piece. The bag that pickle people pass around and everyone else sneaks from when no one's watching.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Spicy Dill Pickle': "We took the Dill Pickle and gave it a backbone. The tang is still there — that sharp, vinegary hit you came for. We just added cayenne to the back end so it doesn't let you off easy. It builds slow, it stays.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Churro': "Cinnamon sugar with enough salt to remind you it's still a pretzel. Sweet but not too sweet. Warm, familiar, and dangerously snackable. The one that works as dessert, road trip snack, or at 11pm when you can't decide.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Original': "Dutch heritage sourdough, sea salt, nothing else. The one that started it all before Gary had a name for it. Clean, salty, and impossible to put down.\n\nSmall-batch sourdough pretzel pieces, hand-seasoned in Wilmington, NC. No MSG.",
  'Limited Edition Octoberfest Pretzel Necklace 2026': "Nine of our Dutch heritage sourdough pretzels strung on a traditional blue and white Bavarian ribbon with a commemorative 2026 tag. Same small-batch recipe we make in Wilmington — just wearable. Wear it in. Snack it down. Hand them to your staff or sell them at the bar. People see it, they want one, and they will find you to ask where you got it.\n\nMade in small batches in Wilmington, NC. Best within a few days of opening. Limited run — once they're gone, they're gone until next year."
};

var LTB_MODAL_DESC = {
  'Margarita in a Bag®': "Everything a margarita should be, without the bar tab. Add tequila and triple sec, top with water, shake and freeze. Or swap in Pinot Grigio if you're serving the wine crowd — works both ways.",
  'Peach Margarita in a Bag®': "Same base as the original, with real peach layered in. Add tequila and triple sec, or go the Pinot Grigio route. Either way, it's summer in a bag.",
  'Mojito in a Bag®': "Real mint and real lime — the kind you'd wait 20 minutes for at a resort bar. Add rum or vodka, top with water, shake and freeze. No muddler required.",
  'Mudslide in a Bag®': "Rich coffee and chocolate, no preservatives. Add coffee liqueur and vodka, top with water, shake and freeze. It counts as dessert.",
  'Blueberry Pomegranate in a Bag®': "Deep, fruity, and easy to love. Add Pinot Noir for a wine slushie, or go with vodka or rum if you want more kick. No explanation required.",
  'Red Sangria in a Bag®': "Real lemon, orange, and grape. Non-GMO. Add red table wine and water, then freeze or pour over ice. Tastes like the patio, not the box.",
  'White Sangria in a Bag®': "The lighter side of sangria. Add white table wine and water, then serve frozen or over ice. Clean, bright, and easy to pass around.",
  'Peach Bellini in a Bag®': "Real peach juice, no shortcuts. Add Chablis or Pinot Grigio, top with water, shake and freeze. The one that makes brunch feel like an occasion.",
  'Pina Colada in a Bag®': "Real dehydrated pineapple and real coconut — nothing artificial. Add rum, top with water, shake and freeze. Put on a playlist. You're basically there.",
  'Strawberry Daiquiri in a Bag®': "Real strawberries, non-GMO. Add rum and shake, or use Pinot Grigio if you're going lighter. The one that disappears first at every party.",
  'Skinny Margarita in a Bag®': "Nine calories. Two grams of carbs. Same margarita ritual — add tequila and triple sec, top with water, shake and freeze — without the next-day math.",
  'Hurricane in a Bag®': "The cocktail that built a legend. Add rum, top with water, shake and freeze. No Mardi Gras required, but it sets the mood either way.",
  'Sangria - Cocktail Mix In A Bag': "Real lemon, orange, and grape. Non-GMO. Add red or white table wine and water, then freeze or pour over ice. Tastes like the patio, not the box.",
  'Piña Colada - Cocktails in a Bag': "Real dehydrated pineapple and real coconut — nothing artificial. Add rum, top with water, shake and freeze. Put on a playlist. You're basically there."
};

document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile nav ──────────────────────────────────────────── */
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobileNav');
  var mobileNavClose = document.getElementById('mobileNavClose');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    if (hamburger) hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    if (hamburger) hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  // Close on overlay click
  if (mobileNav) {
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) closeMobileNav();
    });
  }

  /* ── Flavor card modal ───────────────────────────────────── */
  var PRICES = [5.99, 7.99, 11.99];
  var CDN = 'https://cdn.shopify.com/s/files/1/0814/0396/9847/files/';
  var CLEAR_BAG_IMAGES = {
    'S.P.G.B':                          CDN + 'Untitled_design_4_d393abe7-5126-4ddd-b001-f4434bce30d2.png?v=1755283612',
    'Smokehouse Rancherz':               CDN + 'Shopify_Product_Images_7.png?v=1755283612',
    'Cajun Bayou':                       CDN + 'Shopify_Product_Images_1_4864daec-ee96-4001-a540-4a82150262e6.png?v=1767455905',
    'Creamy Cheddar Bliss':              CDN + 'Add_a_heading_2.png?v=1755613138',
    'Honey Mustard & Onion':             CDN + 'Untitled_design_7.png?v=1732039920',
    'Southwest Buffalo Blaze':           CDN + 'Shopify_Product_Images_54901f6f-37f9-4881-9115-29ad590aad94.png?v=1755610948',
    'Boardwalk':                         CDN + 'Untitleddesign_1_0e83f342-5515-4f07-9675-d9cd6e4c275b.png?v=1755284502',
    'Dill Pickle':                       CDN + 'Untitled_design_a2dfbffd-6c00-4a4d-a800-0e1fc97d6fd2.png?v=1755650552',
    'Spicy Dill Pickle':                 CDN + 'Shopify_Product_Images.png?v=1755650725',
    'Churro':                            CDN + 'Add_a_heading_3_bc14f097-d0ee-47b5-a139-126a9a463cb7.png?v=1755613813',
    'Original':                          CDN + 'Add_a_heading_10.png?v=1755865603',
    'Carolina Krab':                     'https://cdn.shopify.com/s/files/1/0814/0396/9847/files/IMG_5081.jpg?v=1788289710'
  };
  var modalOverlay = document.getElementById('flavor-modal-overlay');
  var modalCloseBtn = document.getElementById('flavor-modal-close');
  var modalBagImg = document.getElementById('modal-bag-img');
  var modalImgWrap = document.getElementById('modal-img-wrap');
  var modalNutrBtn = document.getElementById('modal-nutrition-btn');
  var modalSwatch = document.getElementById('modal-swatch');
  var modalBest = document.getElementById('modal-best');
  var modalName = document.getElementById('modal-name');
  var modalDesc = document.getElementById('modal-desc');
  var modalSizeSel = document.getElementById('modal-size-selector');
  var modalQty = document.getElementById('modal-qty');
  var modalPrice = document.getElementById('modal-price');
  var modalAddBtn = document.getElementById('modal-add-btn');
  var modalQtyVal = 1;
  var modalPrices = PRICES.slice();
  var modalActiveSizeIdx = 0;
  var modalFlavorName = '';
  var currentVariants = null;
  var modalMainImg = '';
  var modalClearImg = '';

  function openFlavorModal(card) {
    var name = card.dataset.name || '';
    var desc = card.dataset.desc || '';
    var img = card.dataset.img || '';
    var color = card.dataset.color || '';
    var best = card.dataset.best === 'true';
    var nutrition = card.dataset.nutrition || '';

    modalFlavorName = name;
    modalQtyVal = 1;
    modalActiveSizeIdx = 1;
    modalMainImg = img;
    modalClearImg = (function() {
      var keys = Object.keys(CLEAR_BAG_IMAGES).sort(function(a,b){ return b.length - a.length; });
      for (var i = 0; i < keys.length; i++) {
        if (name.indexOf(keys[i]) !== -1) return CLEAR_BAG_IMAGES[keys[i]];
      }
      return img;
    })();

    var defaultModalImg = (function() {
      if (window.MODAL_MAIN_IMAGES) {
        var keys = Object.keys(window.MODAL_MAIN_IMAGES).sort(function(a,b){ return b.length - a.length; });
        for (var k = 0; k < keys.length; k++) {
          if (name.indexOf(keys[k]) !== -1) return window.MODAL_MAIN_IMAGES[keys[k]];
        }
      }
      return modalClearImg;
    })();
    if (modalBagImg) { modalBagImg.src = defaultModalImg; modalBagImg.alt = name; }
    if (modalImgWrap) {
      modalImgWrap.classList.remove('showing-nutrition');
      modalImgWrap.setAttribute('data-nutrition', nutrition);
      modalImgWrap.removeAttribute('data-bag');
      if (name && name.indexOf('Necklace') !== -1) {
        modalImgWrap.classList.add('img-contain');
      } else {
        modalImgWrap.classList.remove('img-contain');
      }
    }
    if (modalNutrBtn) {
      modalNutrBtn.style.display = (nutrition || findNutrition(name)) ? '' : 'none';
      modalNutrBtn.textContent = 'Nutrition Facts';
    }
    if (modalSwatch) modalSwatch.style.background = color;
    if (modalBest) modalBest.style.display = best ? '' : 'none';
    if (modalName) modalName.textContent = card.dataset.displayName || name;
    if (modalDesc) {
      var displayName = card.dataset.displayName || name;
      var descText = (MODAL_DESC[name] || desc).trim();
      var stripName = descText.startsWith(displayName) ? displayName : displayName.replace(/ (Pieces|Nuggs)$/, '');
      if (descText.startsWith(stripName)) descText = descText.slice(stripName.length).trim();
      modalDesc.textContent = descText;
    }
    if (modalQty) modalQty.textContent = '1';
    if (modalPrice) modalPrice.textContent = '$' + PRICES[0].toFixed(2);
    if (modalAddBtn) { modalAddBtn.textContent = 'Add to cart'; modalAddBtn.disabled = false; }

    // Parse real Shopify variants if present
    currentVariants = null;
    var variantsRaw = card.dataset.variants;
    if (variantsRaw) {
      try { currentVariants = JSON.parse(variantsRaw); } catch(e) {}
    }

    // Update size selector with real or fallback prices
    var isSingleVariant = currentVariants && currentVariants.length === 1 && currentVariants[0].title === 'Default Title';
    if (modalSizeSel) modalSizeSel.style.display = isSingleVariant ? 'none' : '';
    if (modalSizeSel) {
      var sizeBtns = modalSizeSel.querySelectorAll('.size-btn');
      if (currentVariants && currentVariants.length > 0) {
        modalPrices = currentVariants.map(function(v) { return v.price / 100; });
        var firstAvailable = currentVariants.find(function(v) { return v.available; }) || currentVariants[0];
        sizeBtns.forEach(function(b, i) {
          var v = currentVariants[i];
          if (v) {
            b.style.display = '';
            b.dataset.variantId = v.id;
            b.disabled = !v.available;
            b.style.opacity = v.available ? '' : '0.4';
            var priceEl = b.querySelector('.size-btn-price');
            if (priceEl) priceEl.textContent = '$' + (v.price / 100).toFixed(2);
          } else {
            b.style.display = 'none';
          }
          b.classList.toggle('active', i === 1);
        });
        var preferredVariant = currentVariants[1] && currentVariants[1].available ? currentVariants[1] : (firstAvailable || currentVariants[0]);
        if (modalAddBtn) modalAddBtn.dataset.variantId = preferredVariant ? preferredVariant.id : '';
      } else {
        modalPrices = PRICES.slice();
        sizeBtns.forEach(function(b, i) {
          b.style.display = '';
          b.classList.toggle('active', i === 1);
          b.disabled = false;
          b.style.opacity = '';
          delete b.dataset.variantId;
          var priceEl = b.querySelector('.size-btn-price');
          if (priceEl && PRICES[i] != null) priceEl.textContent = '$' + PRICES[i].toFixed(2);
        });
        if (modalAddBtn) delete modalAddBtn.dataset.variantId;
      }
    }

    if (modalPrice) modalPrice.textContent = '$' + (modalPrices[1] != null ? modalPrices[1] : modalPrices[0]).toFixed(2);

    populateNutritionPanel(name);

    if (modalOverlay) {
      modalOverlay.setAttribute('aria-hidden', 'false');
      modalOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      // Update URL hash so the modal link is shareable
      var slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      window.history.replaceState(null, '', '#' + slug);
    }
  }

  function closeFlavorModal() {
    if (!modalOverlay) return;
    modalOverlay.classList.remove('open');
    modalOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.history.replaceState(null, '', window.location.pathname);
    // Reset nutrition panel
    if (nfPanel) { nfPanel.classList.remove('visible'); nfPanel.setAttribute('aria-hidden', 'true'); }
  }

  // Open on card click / Enter / Space
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.flavor-card');
    if (card) { openFlavorModal(card); return; }
    if (e.target === modalOverlay) closeFlavorModal();
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && document.activeElement && document.activeElement.classList.contains('flavor-card')) {
      e.preventDefault();
      openFlavorModal(document.activeElement);
    }
    if (e.key === 'Escape') closeFlavorModal();
  });

  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeFlavorModal);

  // Modal size selector
  if (modalSizeSel) {
    modalSizeSel.querySelectorAll('.size-btn').forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        modalSizeSel.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        modalActiveSizeIdx = idx;
        if (modalPrice) modalPrice.textContent = '$' + (modalPrices[idx] * modalQtyVal).toFixed(2);
        if (currentVariants && currentVariants[idx] && modalAddBtn) {
          modalAddBtn.dataset.variantId = currentVariants[idx].id;
        }
        if (modalBagImg) {
          if (idx === 1) {
            var mainOverride = window.MODAL_MAIN_IMAGES && (function() {
              var keys = Object.keys(window.MODAL_MAIN_IMAGES).sort(function(a,b){ return b.length - a.length; });
              for (var k = 0; k < keys.length; k++) {
                if (modalFlavorName.indexOf(keys[k]) !== -1) return window.MODAL_MAIN_IMAGES[keys[k]];
              }
            })();
            modalBagImg.src = mainOverride || modalMainImg;
          } else {
            modalBagImg.src = modalClearImg;
          }
        }
      });
    });
  }

  // Modal quantity stepper
  document.addEventListener('click', function (e) {
    var qBtn = e.target.closest('#flavor-modal .qty-btn');
    if (!qBtn) return;
    var dir = parseInt(qBtn.dataset.dir, 10);
    modalQtyVal = Math.max(1, modalQtyVal + dir);
    if (modalQty) modalQty.textContent = modalQtyVal;
    if (modalPrice) modalPrice.textContent = '$' + (modalPrices[modalActiveSizeIdx] * modalQtyVal).toFixed(2);
  });

  // Modal add to cart
  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', function () {
      var variantId = modalAddBtn.dataset.variantId;
      if (!variantId) {
        showCartToast(modalFlavorName + ' added to your cart.');
        closeFlavorModal();
        return;
      }
      modalAddBtn.textContent = 'Adding…';
      modalAddBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: modalQtyVal })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartCount();
          showCartToast(modalFlavorName + ' added to your cart.');
          closeFlavorModal();
        })
        .catch(function () {
          modalAddBtn.textContent = 'Error — try again';
          modalAddBtn.disabled = false;
        });
    });
  }

  /* ── Cart toast ─────────────────────────────────────────── */
  var toastEl = document.createElement('div');
  toastEl.id = 'cart-toast';
  toastEl.className = 'cart-toast';
  toastEl.setAttribute('aria-live', 'polite');
  toastEl.innerHTML = '<span class="cart-toast-icon">✓</span><div class="cart-toast-body"><span id="cart-toast-msg"></span><a href="/cart" class="cart-toast-link">View cart →</a></div>';
  document.body.appendChild(toastEl);

  var toastTimer;
  function showCartToast(message) {
    var msgEl = document.getElementById('cart-toast-msg');
    if (msgEl) msgEl.textContent = message;
    toastEl.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('visible'); }, 3200);
  }

  /* ── Nutrition data ─────────────────────────────────────── */
  var NUTRITION = {
    'S.P.G.B': {
      cal: 130, fat: '6g', fatPct: '8%', satFat: '1g', satFatPct: '5%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '800mg', sodiumPct: '35%',
      carbs: '16g', carbsPct: '6%', fiber: '<1g', fiberPct: '3%',
      sugars: '0g', addedSugars: '0g', addedSugarsPct: '0%', protein: '2g',
      micros: 'Vitamin D 0mcg 0% · Calcium 10mg 0% · Iron 1mg 6% · Potassium 60mg 2%',
      ingredients: 'Sourdough pretzels (wheat flour, corn oil, sea salt, maltodextrin, salt, butter* (cream, salt), cornstarch, buttermilk*, tricalcium phosphate, whey, nonfat dry milk, natural flavor, sunflower oil, color (annato extract, turmeric extract), modified corn starch, silicon dioxide, granulated garlic, black pepper.',
      allergens: 'Contains wheat and milk.'
    },
    'Smokehouse Rancherz': {
      cal: 190, fat: '7g', fatPct: '9%', satFat: '1.5g', satFatPct: '8%', transFat: '0g',
      chol: '5mg', cholPct: '2%', sodium: '470mg', sodiumPct: '20%',
      carbs: '27g', carbsPct: '10%', fiber: '1g', fiberPct: '4%',
      sugars: '3g', addedSugars: '0g', addedSugarsPct: '0%', protein: '4g',
      micros: 'Vitamin D 0mcg 0% · Calcium 40mg 4% · Iron 0.4mg 2% · Potassium 120mg 2%',
      ingredients: 'Sourdough pretzels (wheat, flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), soy oil, maltodextrin, whey, cheddar cheese milk, cheese culture, salt, enzymes, sunflower oil, sodium phosphate, blue cheese, less than 2% citric acid (yellow 5, yellow 6), lactic acid, non-fat dry milk, natural hickory smoke flavor, canola oil, silicone dioxide, onion, sugar, yeast, natural flavor, paprika extract, calcium silicate, buttermilk solids, dextrose, whole milk, dried onion, glutamate, lactic acid powder, chicken flavoring, potato flour, pure vegetable oil, turmeric, onion powder, natural swiss cheese flavor, sea salt butter powder.',
      allergens: 'Contains wheat, milk, and soy.'
    },
    'Cajun Bayou': {
      cal: 160, fat: '7g', fatPct: '9%', satFat: '1.5g', satFatPct: '5%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '270mg', sodiumPct: '9%',
      carbs: '23g', carbsPct: '8%', fiber: '1g', fiberPct: '4%',
      sugars: '1g', addedSugars: '1g', addedSugarsPct: '0%', protein: '3g',
      micros: 'Vitamin D 0mcg 0% · Calcium 40mg 4% · Iron 0.3mg 2% · Potassium 120mg 2%',
      ingredients: 'Sourdough pretzels (wheat flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), soy oil, salt, seasoned salt (salt, sugar, spices (including paprika and turmeric), onion, cornstarch, garlic, tricalcium phosphate (prevents caking), natural flavor, paprika oleoresin (for color)), spice, dried garlic.',
      allergens: 'Contains wheat and soy.'
    },
    'Creamy Cheddar Bliss': {
      cal: 190, fat: '7g', fatPct: '9%', satFat: '1.5g', satFatPct: '8%', transFat: '0g',
      chol: '2mg', cholPct: '2%', sodium: '470mg', sodiumPct: '20%',
      carbs: '23g', carbsPct: '8%', fiber: '1g', fiberPct: '4%',
      sugars: '2g', addedSugars: '0g', addedSugarsPct: '0%', protein: '4g',
      micros: 'Vitamin D 0mcg 0% · Calcium 40mg 4% · Iron 0.4mg 2% · Potassium 100mg 2%',
      ingredients: 'Sourdough pretzels (wheat, flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), soy oil, cheese flavor, granular cheese (milk, cheese culture, salt, enzymes), sodium phosphates, contains less than 2% citric acid, lactic acid (yellow 5, yellow 6), whey, dextrose, dried sour cream powder (sour cream, cultured milk, non-fat milk), whole milk, non-fat dried milk, buttermilk, monosodium glutamate, lactic acid powder, chicken flavoring, potato flour, pure vegetable oil, turmeric, onion powder, natural swiss cheese flavor, sea salt, butter powder.',
      allergens: 'Contains wheat, milk, and soy.'
    },
    'Honey Mustard & Onion': {
      cal: 170, fat: '6g', fatPct: '8%', satFat: '1g', satFatPct: '5%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '260mg', sodiumPct: '11%',
      carbs: '25g', carbsPct: '9%', fiber: '1g', fiberPct: '4%',
      sugars: '1g', addedSugars: '1g', addedSugarsPct: '2%', protein: '3g',
      micros: 'Vitamin D 0mcg 0% · Calcium 6mg 0% · Iron 0.4mg 2% · Potassium 50mg 0%',
      ingredients: 'Sourdough pretzels (wheat flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), cane sugar fructose, dextrose, dried onion, vinegar powder (maltodextrin, white distilled vinegar, and modified food starch), mustard flour, honey powder (maltodextrin and honey), salt, whole oat flour, dried garlic, turmeric, citric acid (acidifier), sea salt, canola oil, paprika, yeast extract (yeast extract, salt), silicon dioxide (flow agent), natural colors.',
      allergens: 'Contains wheat and soy.'
    },
    'Southwest Buffalo Blaze': {
      cal: 160, fat: '7g', fatPct: '9%', satFat: '1.5g', satFatPct: '5%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '270mg', sodiumPct: '9%',
      carbs: '22g', carbsPct: '8%', fiber: '1g', fiberPct: '4%',
      sugars: '1g', addedSugars: '1g', addedSugarsPct: '0%', protein: '3g',
      micros: 'Vitamin D 0mcg 0% · Calcium 40mg 4% · Iron 0.3mg 2% · Potassium 120mg 2%',
      ingredients: 'Sourdough pretzels (wheat, flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), salt, sweet whey, spices (including chipotle pepper), sodium phosphate (11.8%), onion powder, green onion, parsley, natural hickory smoke flavor (contains maltodextrin), dehydrated Franks cayenne pepper sauce (cayenne pepper sauce blend [aged cayenne peppers, distilled vinegar, salt, garlic powder], maltodextrin, rosemary extract [as an antioxidant]), paprika, dextrose, natural spice extractatives.',
      allergens: 'Contains wheat, milk, and soy.'
    },
    'Pink Himalayan Sea Salt & Vinegar': {
      cal: 170, fat: '6g', fatPct: '8%', satFat: '1g', satFatPct: '5%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '220mg', sodiumPct: '10%',
      carbs: '23g', carbsPct: '8%', fiber: '1g', fiberPct: '4%',
      sugars: '0g', addedSugars: '0g', addedSugarsPct: '0%', protein: '3g',
      micros: 'Vitamin D 0mcg 0% · Calcium 5mg 0% · Iron 0.3mg 2% · Potassium 45mg 0%',
      ingredients: 'Choice blended wheat flour (contains one or more of the following: corn, canola, cottonseed, sunflower, soybean oil), malt syrup, corn syrup, yeast, salt and soda. Himalayan salt, sea salt, sodium diacetate, citric acid.',
      allergens: 'Contains wheat, milk*, sesame*, and soy*.'
    },
    'Dill Pickle': {
      cal: 170, fat: '6g', fatPct: '8%', satFat: '1g', satFatPct: '5%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '230mg', sodiumPct: '10%',
      carbs: '23g', carbsPct: '8%', fiber: '1g', fiberPct: '4%',
      sugars: '0g', addedSugars: '0g', addedSugarsPct: '0%', protein: '3g',
      micros: 'Vitamin D 0mcg 0% · Calcium 5mg 0% · Iron 0.3mg 2% · Potassium 45mg 0%',
      ingredients: 'Sourdough pretzels (wheat, flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), salt, maltodextrin, dried garlic, dill weed, vinegar powder (maltodextrin, white distilled vinegar, and modified food starch), citric acid (acidifier), black pepper, canola oil, coriander.',
      allergens: 'Contains wheat and soy.'
    },
    'Spicy Dill Pickle': {
      cal: 190, fat: '7g', fatPct: '9%', satFat: '1g', satFatPct: '6%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '230mg', sodiumPct: '10%',
      carbs: '27g', carbsPct: '11%', fiber: '3g', fiberPct: '11%',
      sugars: '1g', addedSugars: '0g', addedSugarsPct: '0%', protein: '4g',
      micros: 'Vitamin D 0mcg 0% · Calcium 15mg 2% · Iron 0.8mg 4% · Potassium 180mg 4%',
      ingredients: 'Sourdough pretzels (wheat, flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), salt, maltodextrin, dried garlic, dill weed, vinegar powder (maltodextrin, white distilled vinegar, and modified food starch), citric acid (acidifier), black pepper, canola oil, coriander, cayenne pepper.',
      allergens: 'Contains wheat and soy.'
    },
    'Churro': {
      cal: 170, fat: '6g', fatPct: '8%', satFat: '1g', satFatPct: '5%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '200mg', sodiumPct: '9%',
      carbs: '23g', carbsPct: '8%', fiber: '1g', fiberPct: '4%',
      sugars: '1g', addedSugars: '1g', addedSugarsPct: '0%', protein: '3g',
      micros: 'Vitamin D 0mcg 0% · Calcium 5mg 0% · Iron 0.3mg 2% · Potassium 45mg 0%',
      ingredients: 'Sourdough pretzels (wheat, flour, corn oil, salt, malt, honey, vegetable fiber yeast, soda), cinnamon, sugar, bean oil.',
      allergens: 'Contains wheat and soy.'
    },
    'Original': {
      cal: 110, fat: '0g', fatPct: '0%', satFat: '0g', satFatPct: '0%', transFat: '0g',
      chol: '0mg', cholPct: '0%', sodium: '200mg', sodiumPct: '9%',
      carbs: '23g', carbsPct: '8%', fiber: '1g', fiberPct: '4%',
      sugars: '0g', addedSugars: '0g', addedSugarsPct: '0%', protein: '3g',
      micros: 'Vitamin D 0mcg 0% · Calcium 5mg 0% · Iron 0.3mg 2% · Potassium 43mg 0%',
      ingredients: 'Choice blended wheat flour (contains one or more of the following: corn, canola, cottonseed, sunflower, soybean oil), malt syrup, corn syrup, yeast, salt.',
      allergens: 'Contains wheat, milk*, sesame*, and soy*.'
    }
  };

  function findNutrition(name) {
    if (NUTRITION[name]) return NUTRITION[name];
    var n = name.toLowerCase();
    var keys = Object.keys(NUTRITION);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i].toLowerCase();
      if (k === n || n.indexOf(k) !== -1 || k.indexOf(n) !== -1) return NUTRITION[keys[i]];
    }
    return null;
  }

  function populateNutritionPanel(name) {
    var d = findNutrition(name);
    var panel = document.getElementById('modal-nutrition-panel');
    if (!d || !panel) return;
    document.getElementById('nf-calories').textContent = d.cal;
    document.getElementById('nf-fat').textContent = d.fat;
    document.getElementById('nf-fat-pct').textContent = d.fatPct;
    document.getElementById('nf-sat-fat').textContent = d.satFat;
    document.getElementById('nf-sat-fat-pct').textContent = d.satFatPct;
    document.getElementById('nf-trans-fat').textContent = d.transFat;
    document.getElementById('nf-chol').textContent = d.chol;
    document.getElementById('nf-chol-pct').textContent = d.cholPct;
    document.getElementById('nf-sodium').textContent = d.sodium;
    document.getElementById('nf-sodium-pct').textContent = d.sodiumPct;
    document.getElementById('nf-carbs').textContent = d.carbs;
    document.getElementById('nf-carbs-pct').textContent = d.carbsPct;
    document.getElementById('nf-fiber').textContent = d.fiber;
    document.getElementById('nf-fiber-pct').textContent = d.fiberPct;
    document.getElementById('nf-sugars').textContent = d.sugars;
    document.getElementById('nf-added-sugars').textContent = d.addedSugars;
    document.getElementById('nf-added-sugars-pct').textContent = d.addedSugarsPct;
    document.getElementById('nf-protein').textContent = d.protein;
    document.getElementById('nf-micros').textContent = d.micros;
    document.getElementById('nf-ingredients').textContent = d.ingredients;
    document.getElementById('nf-allergens').textContent = d.allergens;
  }

  // Nutrition panel toggle
  var nfPanel = document.getElementById('modal-nutrition-panel');
  var nfBackBtn = document.getElementById('nf-back-btn');

  document.addEventListener('click', function (e) {
    if (e.target.closest('#modal-nutrition-btn')) {
      if (nfPanel) { nfPanel.classList.add('visible'); nfPanel.setAttribute('aria-hidden', 'false'); }
    } else if (e.target.closest('#nf-back-btn')) {
      if (nfPanel) { nfPanel.classList.remove('visible'); nfPanel.setAttribute('aria-hidden', 'true'); }
    }
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ── Sampler picker ──────────────────────────────────────── */
  var CDN = 'https://cdn.shopify.com/s/files/1/0814/0396/9847/files/';

  var FLAVORS = [
    { name: 'S.P.G.B',                          color: '#C0392B', img: 'pretzel-spgb.png' },
    { name: 'Smokehouse Rancherz',               color: '#C05A2E', img: 'pretzel-rancherz.png' },
    { name: 'Cajun Bayou',                       color: '#5B7A4F', img: 'pretzel-cajun.png' },
    { name: 'Creamy Cheddar Bliss',              color: '#3F6B8C', img: 'pretzel-cheddar.png' },
    { name: 'Honey Mustard & Onion',             color: '#C9A24B', img: 'pretzel-honey-mustard.png' },
    { name: 'Southwest Buffalo Blaze',           color: '#4F9C8D', img: 'pretzel-buffalo-blaze.png' },
    { name: 'Boardwalk',                         color: '#6FAEB0', img: 'pretzel-pink-himalayan.png' },
    { name: 'Dill Pickle',                       color: '#A6B84A', img: 'pretzel-dill-pickle.png' },
    { name: 'Spicy Dill Pickle',                 color: '#C0392B', img: 'pretzel-spicy-dill.png' },
    { name: 'Churro',                            color: '#D9A23B', img: 'pretzel-churro.png' },
    { name: 'Carolina Krab',                     color: '#C4682A', img: 'sampler-slot-2.png' },
    { name: 'Original',                          color: '#C8A96E', img: 'Untitled_design__4_-removebg-preview.png' }
  ];

  var pickerEl = document.getElementById('flavor-picker');
  var counterEl = document.getElementById('pick-counter');
  var addSamplerBtn = document.getElementById('sampler-add-btn');
  var MAX = 4;
  var selected = [];

  if (pickerEl) {
    FLAVORS.forEach(function (f) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pick-btn';
      btn.dataset.flavor = f.name;
      var matchCard = document.querySelector('.flavor-card[data-name*="' + f.name + '"]');
      var isBestSeller = matchCard && matchCard.dataset.best === 'true';
      btn.innerHTML = '<span class="pick-dot" style="background:' + f.color + ';"></span>' + f.name + (isBestSeller ? ' <span class="pick-best-star" aria-label="Best seller">★</span>' : '');
      btn.addEventListener('click', function () {
        if (btn.classList.contains('selected')) {
          btn.classList.remove('selected');
          selected = selected.filter(function (n) { return n !== f.name; });
        } else if (selected.length < MAX) {
          btn.classList.add('selected');
          selected.push(f.name);
        }
        renderSamplerFan();
        updatePickerState();
      });
      pickerEl.appendChild(btn);
    });
  }

  function updatePickerState() {
    var count = selected.length;
    if (counterEl) {
      if (count === 0) { counterEl.innerHTML = 'Choose <strong>4 flavors</strong> to get started'; counterEl.classList.remove('complete'); }
      else if (count < MAX) { counterEl.innerHTML = '<strong>' + count + ' of 4</strong> chosen — pick ' + (MAX - count) + ' more'; counterEl.classList.remove('complete'); }
      else { counterEl.innerHTML = '&#10003; <strong>4 of 4 chosen</strong> — ready to add to cart'; counterEl.classList.add('complete'); }
    }
    if (addSamplerBtn) {
      addSamplerBtn.disabled = count < MAX;
      addSamplerBtn.textContent = count < MAX ? 'Choose ' + (MAX - count) + ' more' : 'Add sampler to cart';
    }
    // disable unchosen buttons when at max
    if (pickerEl) {
      pickerEl.querySelectorAll('.pick-btn').forEach(function (b) {
        b.disabled = (count >= MAX && !b.classList.contains('selected'));
      });
    }
  }

  function renderSamplerFan() {
    var art = document.getElementById('sampler-art');
    if (!art) return;
    var slots = art.querySelectorAll('.sampler-bag-slot');

    // Clear all slots first
    slots.forEach(function (slot) {
      if (slot.classList.contains('filled')) {
        slot.classList.remove('filled');
        // delay DOM removal until transition ends
        var oldImg = slot.querySelector('img');
        if (oldImg) {
          setTimeout(function () { if (slot.querySelector('img') === oldImg) slot.removeChild(oldImg); }, 380);
        }
        delete slot.dataset.flavor;
      }
    });

    // Re-populate slots in selection order
    selected.forEach(function (name, i) {
      var flavor = null;
      for (var j = 0; j < FLAVORS.length; j++) { if (FLAVORS[j].name === name) { flavor = FLAVORS[j]; break; } }
      if (!flavor || i >= slots.length) return;
      var slot = slots[i];
      slot.dataset.flavor = name;
      var img = document.createElement('img');
      img.src = (window.SAMPLER_BAG_IMAGES && window.SAMPLER_BAG_IMAGES[flavor.name]) || (function() { var keys = Object.keys(CLEAR_BAG_IMAGES).sort(function(a,b){ return b.length - a.length; }); for (var k=0; k<keys.length; k++) { if (flavor.name.indexOf(keys[k]) !== -1) return CLEAR_BAG_IMAGES[keys[k]]; } }()) || CDN + flavor.img;
      img.alt = name + ' pretzel bag';
      // Remove any leftover img before appending
      var prev = slot.querySelector('img');
      if (prev) slot.removeChild(prev);
      slot.appendChild(img);
      // Trigger enter animation on next frame
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { slot.classList.add('filled'); });
      });
    });
  }

  if (addSamplerBtn) {
    addSamplerBtn.addEventListener('click', function () {
      if (selected.length < MAX) return;
      var samplerVariantId = addSamplerBtn.dataset.variantId;
      if (!samplerVariantId) {
        // Fallback: no variant configured, alert
        alert('Sampler variant not configured. Please set a variant ID in section settings.');
        return;
      }
      var properties = {};
      selected.forEach(function (name, i) {
        properties['Flavor ' + (i + 1)] = name;
      });
      addSamplerBtn.textContent = 'Adding…';
      addSamplerBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(samplerVariantId, 10),
          quantity: 1,
          properties: properties
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addSamplerBtn.textContent = 'Added to cart!';
          updateCartCount();
          showCartToast('Your 4-pack sampler is in the cart.');
          setTimeout(function () {
            // reset picker and fan
            selected = [];
            if (pickerEl) pickerEl.querySelectorAll('.pick-btn').forEach(function (b) { b.classList.remove('selected'); b.disabled = false; });
            renderSamplerFan();
            updatePickerState();
          }, 2000);
        })
        .catch(function () {
          addSamplerBtn.textContent = 'Error — try again';
          addSamplerBtn.disabled = false;
        });
    });
  }

  /* ── Lt. Blender's add to cart ──────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ltb-add-btn');
    if (!btn) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.textContent = '…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        updateCartCount();
        showCartToast((item.product_title || 'Item') + ' added to your cart.');
        btn.textContent = '✓';
        setTimeout(function () { btn.textContent = '+'; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = '!';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = '+'; }, 1500);
      });
  });

  /* ── Lt. Blender's flavor modal ─────────────────────────── */
  var ltbOverlay    = document.getElementById('ltb-modal-overlay');
  var ltbCloseBtn   = document.getElementById('ltb-modal-close');
  var ltbModalImg   = document.getElementById('ltb-modal-img');
  var ltbModalSwatch = document.getElementById('ltb-modal-swatch');
  var ltbModalBest  = document.getElementById('ltb-modal-best');
  var ltbModalName  = document.getElementById('ltb-modal-name');
  var ltbModalDesc  = document.getElementById('ltb-modal-desc');
  var ltbModalQty   = document.getElementById('ltb-modal-qty');
  var ltbModalPrice = document.getElementById('ltb-modal-price');
  var ltbModalAddBtn = document.getElementById('ltb-modal-add-btn');
  var ltbQtyVal = 1;
  var ltbBasePrice = 0;
  var ltbVariantId = null;

  function openLtbModal(card) {
    var name     = card.dataset.name || '';
    var desc     = card.dataset.desc || '';
    var img      = card.dataset.img || '';
    var color    = card.dataset.color || '#1CC435';
    var best     = card.dataset.best === 'true';
    var priceStr = card.dataset.price || '';
    var variants = null;

    try { if (card.dataset.variants) variants = JSON.parse(card.dataset.variants); } catch(e) {}

    ltbQtyVal = 1;
    ltbVariantId = variants && variants.length > 0 ? variants[0].id : null;
    ltbBasePrice = variants && variants.length > 0 ? variants[0].price / 100 : parseFloat(priceStr.replace(/[^0-9.]/g, '')) || 0;

    if (ltbModalImg)    { ltbModalImg.src = img; ltbModalImg.alt = name; }
    if (ltbModalSwatch) ltbModalSwatch.style.background = color;
    if (ltbModalBest)   ltbModalBest.style.display = best ? '' : 'none';
    if (ltbModalName)   ltbModalName.textContent = name;
    var ltbDesc = LTB_MODAL_DESC[name];
    if (!ltbDesc) {
      var nl = name.toLowerCase();
      var ltbKeys = Object.keys(LTB_MODAL_DESC);
      for (var li = 0; li < ltbKeys.length; li++) {
        var lk = ltbKeys[li].toLowerCase();
        if (nl.indexOf(lk.replace(/[®]/g,'').trim()) !== -1 || lk.indexOf(nl) !== -1) { ltbDesc = LTB_MODAL_DESC[ltbKeys[li]]; break; }
        var lkCore = lk.replace(' in a bag®','').replace(' in a bag','').trim();
        if (nl.indexOf(lkCore) !== -1) { ltbDesc = LTB_MODAL_DESC[ltbKeys[li]]; break; }
      }
    }
    if (ltbModalDesc) ltbModalDesc.textContent = ltbDesc || desc;
    if (ltbModalQty)    ltbModalQty.textContent = '1';
    if (ltbModalPrice)  ltbModalPrice.textContent = ltbBasePrice > 0 ? '$' + ltbBasePrice.toFixed(2) : priceStr;
    if (ltbModalAddBtn) { ltbModalAddBtn.textContent = 'Add to cart'; ltbModalAddBtn.disabled = false; }

    if (ltbOverlay) {
      ltbOverlay.setAttribute('aria-hidden', 'false');
      ltbOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeLtbModal() {
    if (!ltbOverlay) return;
    ltbOverlay.classList.remove('open');
    ltbOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.ltb-flavor-card');
    if (card && !e.target.closest('.ltb-add-btn')) { openLtbModal(card); return; }
    if (e.target === ltbOverlay) closeLtbModal();
  });

  if (ltbCloseBtn) ltbCloseBtn.addEventListener('click', closeLtbModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ltbOverlay && ltbOverlay.classList.contains('open')) closeLtbModal();
  });

  document.addEventListener('click', function (e) {
    var qBtn = e.target.closest('#ltb-modal .qty-btn');
    if (!qBtn) return;
    var dir = parseInt(qBtn.dataset.dir, 10);
    ltbQtyVal = Math.max(1, ltbQtyVal + dir);
    if (ltbModalQty) ltbModalQty.textContent = ltbQtyVal;
    if (ltbModalPrice && ltbBasePrice > 0) ltbModalPrice.textContent = '$' + (ltbBasePrice * ltbQtyVal).toFixed(2);
  });

  if (ltbModalAddBtn) {
    ltbModalAddBtn.addEventListener('click', function () {
      if (!ltbVariantId) {
        showCartToast((ltbModalName ? ltbModalName.textContent : 'Item') + ' added to your cart.');
        closeLtbModal();
        return;
      }
      ltbModalAddBtn.textContent = 'Adding…';
      ltbModalAddBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(ltbVariantId, 10), quantity: ltbQtyVal })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartCount();
          showCartToast((ltbModalName ? ltbModalName.textContent : 'Item') + ' added to your cart.');
          closeLtbModal();
        })
        .catch(function () {
          ltbModalAddBtn.textContent = 'Error — try again';
          ltbModalAddBtn.disabled = false;
        });
    });
  }

  /* ── Review carousel ─────────────────────────────────────── */
  var reviewGrid = document.getElementById('reviewGrid');
  var reviewPrev = document.getElementById('reviewPrev');
  var reviewNext = document.getElementById('reviewNext');

  if (reviewGrid && reviewPrev && reviewNext) {
    var cards = reviewGrid.querySelectorAll('.review-card');
    var visibleCount = window.innerWidth <= 600 ? 1 : window.innerWidth <= 980 ? 1 : 3;
    var currentIdx = 0;

    function showReviews() {
      visibleCount = window.innerWidth <= 600 ? 1 : window.innerWidth <= 980 ? 1 : 3;
      cards.forEach(function (c, i) {
        c.style.display = (i >= currentIdx && i < currentIdx + visibleCount) ? '' : 'none';
      });
      reviewPrev.disabled = currentIdx === 0;
      reviewNext.disabled = currentIdx + visibleCount >= cards.length;
    }

    reviewPrev.addEventListener('click', function () {
      if (currentIdx > 0) { currentIdx -= visibleCount; if (currentIdx < 0) currentIdx = 0; showReviews(); }
    });
    reviewNext.addEventListener('click', function () {
      if (currentIdx + visibleCount < cards.length) { currentIdx += visibleCount; showReviews(); }
    });

    window.addEventListener('resize', function () { currentIdx = 0; showReviews(); });
    showReviews();
  }

  /* ── Cart quantity update (cart page) ────────────────────── */
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.dataset.key;
      var qty = parseInt(input.value, 10);
      if (!key || isNaN(qty)) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('.cart-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.key;
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });


}); // end DOMContentLoaded


/* ── Store locator (global, called from inline onclick) ───── */
var STORES = [
  {n:"Pickle & Taps",a:"1207 S 13th St",c:"Wilmington",s:"NC",lat:34.2182,lng:-77.9512},
  {n:"Salt Marsh Market",a:"100 Suite A Medlin Dr",c:"Surf City",s:"NC",lat:34.4356,lng:-77.5509},
  {n:"Heritage Farm Store",a:"2519 East Ash St",c:"Goldsboro",s:"NC",lat:35.3849,lng:-77.9925},
  {n:"The Bar Cart",a:"713 Penn Ave",c:"Reading",s:"PA",lat:40.3356,lng:-75.9268},
  {n:"Ironclad Brewing / Pour Tap Room",a:"115 N 2nd St",c:"Wilmington",s:"NC",lat:34.2373,lng:-77.9441},
  {n:"The Art Sea Shop",a:"3 S 2nd St",c:"Wilmington",s:"NC",lat:34.2366,lng:-77.9436},
  {n:"Aunt Kate's Cookies",a:"1232 Arboretum Dr",c:"Wilmington",s:"NC",lat:34.2432,lng:-77.8638},
  {n:"Jimmy's Wrightsville Beach",a:"5 N Lumina Ave",c:"Wrightsville Beach",s:"NC",lat:34.2090,lng:-77.7966},
  {n:"Sip Tiki Bar",a:"214 N Water St",c:"Wilmington",s:"NC",lat:34.2380,lng:-77.9440},
  {n:"Mike's Farm",a:"1600 Haw Branch Rd",c:"Beulaville",s:"NC",lat:34.9196,lng:-77.9591},
  {n:"Broomtail Brewing",a:"6404 Amsterdam Way Unit 100",c:"Wilmington",s:"NC",lat:34.2860,lng:-77.8700},
  {n:"Bigger's Market",a:"6250 Market St",c:"Wilmington",s:"NC",lat:34.2820,lng:-77.8620},
  {n:"Throw Coast",a:"1026 Appleton Way NE Unit 140",c:"Leland",s:"NC",lat:34.2140,lng:-78.0370},
  {n:"The Butcher's Market - Porter's Neck",a:"188 Porters Neck Rd",c:"Wilmington",s:"NC",lat:34.3000,lng:-77.8060},
  {n:"Mitchell's Butchery",a:"2678 NC Hwy 89 E",c:"Walnut Cove",s:"NC",lat:36.2968,lng:-80.1437},
  {n:"Butler's Farm Market",a:"5600 Ocean Hwy W",c:"Shallotte",s:"NC",lat:33.9732,lng:-78.3836},
  {n:"Hi-Wire Brewing",a:"1020 Princess St",c:"Wilmington",s:"NC",lat:34.2340,lng:-77.9440},
  {n:"Bigger's Market - Carolina Beach",a:"6458 Carolina Beach Rd",c:"Wilmington",s:"NC",lat:34.1340,lng:-77.9290},
  {n:"Leland Brewing",a:"2115 Ale Ave",c:"Leland",s:"NC",lat:34.2140,lng:-78.0370},
  {n:"Midland Provisions",a:"596 Highway 24/27 W",c:"Midland",s:"NC",lat:35.2279,lng:-80.4762},
  {n:"Hidden Ships Distillery",a:"116 Charlie Medlin Drive",c:"Surf City",s:"NC",lat:34.4356,lng:-77.5509},
  {n:"Jackson's General Store",a:"456 West Main Street",c:"Sylva",s:"NC",lat:35.3729,lng:-83.2221},
  {n:"Trailer Bar",a:"1701 N New River Dr",c:"Surf City",s:"NC",lat:34.4370,lng:-77.5510},
  {n:"Carolina Country Store",a:"119 S Water St",c:"Wilmington",s:"NC",lat:34.2340,lng:-77.9420},
  {n:"Castle Bay Country Club",a:"107 Links Ct",c:"Hampstead",s:"NC",lat:34.3593,lng:-77.7196},
  {n:"Salty Turtle",a:"103 Triton Lane",c:"Surf City",s:"NC",lat:34.4340,lng:-77.5480},
  {n:"Steve's Garden Market & Butchery",a:"610 N Churton St",c:"Hillsborough",s:"NC",lat:36.0749,lng:-79.1003},
  {n:"Veggie Wagon",a:"608 Lake Park Blvd S",c:"Carolina Beach",s:"NC",lat:34.0365,lng:-77.8958},
  {n:"The Bend ILM",a:"7227 Market St",c:"Wilmington",s:"NC",lat:34.2820,lng:-77.8300},
  {n:"Gingham & Posh",a:"5210 B Hollyridge Dr",c:"Raleigh",s:"NC",lat:35.8660,lng:-78.7070},
  {n:"Blue Mountain Distributors",a:"551 A White Dr",c:"Fletcher",s:"NC",lat:35.4296,lng:-82.4982},
  {n:"Waterline Brewing",a:"721 Surry St",c:"Wilmington",s:"NC",lat:34.2420,lng:-77.9500},
  {n:"Pro Stop",a:"10806 US HWY 21 S",c:"Glade Valley",s:"NC",lat:36.4543,lng:-81.0543},
  {n:"DeWayne's Inc",a:"1525 Outlet Center Dr",c:"Selma",s:"NC",lat:35.5379,lng:-78.2836},
  {n:"The Butcher's Market - Oleander",a:"4512 Oleander Dr",c:"Wilmington",s:"NC",lat:34.2100,lng:-77.8920},
  {n:"Atrium Health - Pink Pinafore Gift Shop",a:"920 Church Street N",c:"Concord",s:"NC",lat:35.4088,lng:-80.5796},
  {n:"Shop N Save Market",a:"683 Millswood Dr",c:"Mooresville",s:"NC",lat:35.5762,lng:-80.8101},
  {n:"Warm Glow Candle Co.",a:"519 West Water St",c:"Centerville",s:"IN",lat:39.8175,lng:-84.9958},
  {n:"The Extra Ingredient",a:"801 Friendly Center Rd",c:"Greensboro",s:"NC",lat:36.0726,lng:-79.7920},
  {n:"Seagate Bottle Shop",a:"6005 Oleander Dr",c:"Wilmington",s:"NC",lat:34.2140,lng:-77.8920},
  {n:"Mears Jewelry",a:"121 Whitfield St",c:"Enfield",s:"NC",lat:36.1793,lng:-77.6639},
  {n:"Artistry Florals Inc",a:"18509 Statesville Rd",c:"Cornelius",s:"NC",lat:35.4824,lng:-80.8873},
  {n:"The Nook of Wilson",a:"2801 Ward Blvd",c:"Wilson",s:"NC",lat:35.7215,lng:-77.9155},
  {n:"Kudzu Bakery",a:"1100 Bowman Road",c:"Mount Pleasant",s:"SC",lat:32.8323,lng:-79.8284},
  {n:"Thayer's Gifts",a:"302 Main Street",c:"Greenwood",s:"SC",lat:34.1954,lng:-82.1618},
  {n:"Chow Town",a:"1101 N 4th St",c:"Wilmington",s:"NC",lat:34.2470,lng:-77.9510},
  {n:"Edge City Brewery",a:"6209 Old Post Rd",c:"Charlotte",s:"NC",lat:35.2100,lng:-80.7880},
  {n:"Daisy Boutique",a:"3188 Waltham Blvd",c:"Burlington",s:"NC",lat:36.0957,lng:-79.4378},
  {n:"NOFO",a:"2014 Fairview Rd",c:"Raleigh",s:"NC",lat:35.7970,lng:-78.6490},
  {n:"Edenton Farmers Market",a:"102 Horniblow Point Rd",c:"Edenton",s:"NC",lat:36.0579,lng:-76.6077},
  {n:"Tucker Brewing Company",a:"2003 S Bibb Drive",c:"Tucker",s:"GA",lat:33.8512,lng:-84.2197},
  {n:"Rhino Market & Deli",a:"1500 W Moorehead Street",c:"Charlotte",s:"NC",lat:35.2130,lng:-80.8740},
  {n:"Skyline Cafe",a:"929 N Front St",c:"Wilmington",s:"NC",lat:34.2410,lng:-77.9450},
  {n:"Durham Coop Market",a:"1111 W Chapel Hill St",c:"Durham",s:"NC",lat:35.9940,lng:-78.8990},
  {n:"NoFo Brew Co.",a:"6150 GA-400",c:"Cumming",s:"GA",lat:34.2073,lng:-84.1402},
  {n:"Tap Yard",a:"1610 Automotive Way",c:"Raleigh",s:"NC",lat:35.7970,lng:-78.5980},
  {n:"Homewood Nursery",a:"10809 Honeycutt Rd",c:"Raleigh",s:"NC",lat:35.9220,lng:-78.6870},
  {n:"The Brass Bird",a:"320 Main Street",c:"Pineville",s:"NC",lat:35.0826,lng:-80.8873},
  {n:"Mulberry Lane Country Store",a:"4009 Emerson Ave",c:"Parkersburg",s:"WV",lat:39.2667,lng:-81.5615},
  {n:"The Eis House",a:"144 Academy St",c:"Mexico",s:"NY",lat:43.4648,lng:-76.2282},
  {n:"Stripling's General Store",a:"4501 Monroe Hwy",c:"Bogart",s:"GA",lat:33.9457,lng:-83.5332},
  {n:"Pine Valley Market - College Rd",a:"3520 College Rd",c:"Wilmington",s:"NC",lat:34.1890,lng:-77.8720},
  {n:"Pine Valley Market - Pavillion",a:"1611 Pavillion Place",c:"Wilmington",s:"NC",lat:34.1790,lng:-77.8750},
  {n:"Porters Neck Country Club",a:"8403 Vintage Club Circle",c:"Wilmington",s:"NC",lat:34.3210,lng:-77.7990},
  {n:"Trendsetters Boutique",a:"1459 Flat Creek Road",c:"Lancaster",s:"SC",lat:34.7204,lng:-80.7734},
  {n:"By The Beach Brewing",a:"104 Old Eastwood Rd",c:"Wilmington",s:"NC",lat:34.2220,lng:-77.8920},
  {n:"Fermental",a:"600 S 17th St",c:"Wilmington",s:"NC",lat:34.2330,lng:-77.9450},
  {n:"Brunswick Beer Xchange",a:"113 Village Rd NE",c:"Leland",s:"NC",lat:34.2200,lng:-78.0210},
  {n:"Candy's Exxon",a:"6132 Carolina Beach Rd",c:"Wilmington",s:"NC",lat:34.1420,lng:-77.9250},
  {n:"Roberts Grocery",a:"32 N Lumina Ave",c:"Wrightsville Beach",s:"NC",lat:34.2090,lng:-77.7970},
  {n:"Brewers Kettle",a:"4718 Oleander Dr",c:"Wilmington",s:"NC",lat:34.2150,lng:-77.8860},
  {n:"NOMA",a:"7006 Wrightsville Ave",c:"Wilmington",s:"NC",lat:34.2210,lng:-77.8620},
  {n:"Shoreline Market",a:"1314 NC-210 Unit 1",c:"Sneads Ferry",s:"NC",lat:34.5504,lng:-77.3936},
  {n:"Flytrap Brewing",a:"319 Walnut St",c:"Wilmington",s:"NC",lat:34.2360,lng:-77.9440},
  {n:"Monkey Market",a:"5111 Carolina Beach Rd",c:"Wilmington",s:"NC",lat:34.1570,lng:-77.9270},
  {n:"Pour Fellas Pub",a:"7211 Market St",c:"Wilmington",s:"NC",lat:34.2820,lng:-77.8300},
  {n:"The Vintage Hammer",a:"122 Washington Ave",c:"Hampshire",s:"IL",lat:42.1064,lng:-88.5292},
  {n:"Cozy Oven Bakery",a:"361 Ocean Forest Dr NW",c:"Calabash",s:"NC",lat:33.8899,lng:-78.5613},
  {n:"Tidal Market III",a:"328 Greenville Ave",c:"Wilmington",s:"NC",lat:34.2220,lng:-77.8920},
  {n:"Village Market",a:"26 S 2nd St",c:"Wilmington",s:"NC",lat:34.2340,lng:-77.9430},
  {n:"Wine Maestro",a:"543 Deauville Rd",c:"Statesville",s:"NC",lat:35.7827,lng:-80.8873},
  {n:"Butlers Farm Market",a:"210 N 6th St Unit B",c:"Wilmington",s:"NC",lat:34.2390,lng:-77.9440},
  {n:"The Hive on the Hill",a:"101 Scotts Hill Loop Rd",c:"Wilmington",s:"NC",lat:34.3200,lng:-77.8050}
];

function haversine(lat1, lon1, lat2, lon2) {
  var R = 3958.8; // miles
  var dLat = (lat2 - lat1) * Math.PI / 180;
  var dLon = (lon2 - lon1) * Math.PI / 180;
  var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

function locatorSearch() {
  var zip = (document.getElementById('locatorZip').value || '').trim();
  var el = document.getElementById('locatorResults');
  if (!/^\d{5}$/.test(zip)) {
    el.innerHTML = '<p class="locator-msg">Please enter a valid 5-digit zip code.</p>';
    return;
  }
  el.innerHTML = '<p class="locator-msg">Searching…</p>';
  fetch('https://api.zippopotam.us/us/' + zip)
    .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function (data) {
      var lat = parseFloat(data.places[0].latitude);
      var lng = parseFloat(data.places[0].longitude);
      var radius = 50;
      var results = STORES.map(function (s) { return { store: s, dist: haversine(lat, lng, s.lat, s.lng) }; })
        .filter(function (x) { return x.dist <= radius; })
        .sort(function (a, b) { return a.dist - b.dist; });
      var seen = {};
      results = results.filter(function (x) {
        if (seen[x.store.n]) return false;
        seen[x.store.n] = true;
        return true;
      });
      if (!results.length) {
        el.innerHTML = '<p class="locator-msg">No retailers found within 50 miles of ' + zip + '. Try a nearby zip or <a href="mailto:sales@drinknpretzels.com" style="color:var(--rust)">contact us</a> to find the closest option.</p>';
        return;
      }
      var html = '<div class="locator-results-grid">';
      results.forEach(function (x) {
        var mi = x.dist < 1 ? '< 1 mi' : Math.round(x.dist) + ' mi';
        html += '<div class="store-card"><div class="store-card-name">' + x.store.n + '</div><div class="store-card-addr">' + x.store.a + '<br>' + x.store.c + ', ' + x.store.s + '</div><div class="store-card-dist">' + mi + ' away</div></div>';
      });
      html += '</div>';
      el.innerHTML = html;
    })
    .catch(function () { el.innerHTML = '<p class="locator-msg">Zip code not found. Please check the zip and try again.</p>'; });
}

document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('locatorForm');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); locatorSearch(); });
  var inp = document.getElementById('locatorZip');
  if (inp) inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); locatorSearch(); } });
});

// Auto-open flavor modal from URL hash (e.g. drinknpretzels.com/#spgb)
document.addEventListener('DOMContentLoaded', function () {
  var hash = window.location.hash.replace('#', '').toLowerCase();
  if (!hash) return;
  setTimeout(function () {
    var cards = document.querySelectorAll('.flavor-card[data-name]');
    for (var i = 0; i < cards.length; i++) {
      var cardSlug = (cards[i].dataset.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (cardSlug === hash || cardSlug.indexOf(hash) === 0) {
        cards[i].click();
        break;
      }
    }
  }, 400);
});
